import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { AcademicYearService } from 'src/app/private/services/acedemicyear.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-delete-academic-year',
  imports: [SharedModule],
  templateUrl: './delete-academic-year.component.html',
  styleUrl: './delete-academic-year.component.scss'
})
export class DeleteAcademicYearComponent {

 @Output() closeDialog = new EventEmitter<any>();
  @Input() academicYearData: any;
  @Output() reload = new EventEmitter<any>();
  isLoading = false;

  constructor(
    private api : AcademicYearService,
    private localStorage: LocalStorageService,
    private messageService: MessageService
  ) {}

  handleCloseDialog() {
    this.closeDialog.emit();
  }

  getFullName(user: any) {
    return [user?.prefix, user?.first_name, user?.last_name]
      .filter(name => !!name)
      .join(' ');
  }

  handleDelete(){
    this.isLoading = true;

    const payload = {
      id : this.academicYearData.id,
      organization_id : this.localStorage.getOrganizationId(),
      campus_id : this.localStorage.getCampusId()
    }

    this.api.deleteAcademicYear(payload).subscribe({
      next: (response) => {
        this.isLoading = false;
        this.reload.emit();
        this.messageService.add({severity:'success', summary: 'Success', detail: 'Academic Year deleted successfully'});
        this.closeDialog.emit();
      },
      error: (error) => {
        this.messageService.add({severity:'error', summary: 'Error', detail: 'Something went wrong'});
        this.isLoading = false;
      }
    }
    );

  }

}
